const Settings = {
  id: null,
  locale: "",
};

export default Settings;
